var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoistEllipseDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 130,
    viewBox: "0 0 216 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 110.564,
    cy: 114.756,
    rx: 110.564,
    ry: 114.756,
    transform: "matrix(-1 0 0 1 321.736 -100.416)",
    fill: "#008000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.000411987 -21.816C0.000411987 40.6938 50.6746 91.368 113.184 91.368C175.694 91.368 226.368 40.6938 226.368 -21.816C226.368 -84.3258 175.694 -135 113.184 -135C50.6746 -135 0.000411987 -84.3258 0.000411987 -21.816Z",
    fill: "#008000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoistEllipseDesktop);
export default __webpack_public_path__ + "static/media/joist_ellipse_desktop.9270233200b62ebd60bc8e5fe7d2d624.svg";
export { ForwardRef as ReactComponent };